import {put, takeEvery} from 'redux-saga/effects';
import {showNotification} from 'react-admin';
import i18n from 'i18next';
import API from '../api';

import {
    documentCreateSuccess,
    documentCreateError
} from '../actions/documentActions';

import {
    DOCUMENT_CREATE_REQUEST,
    DOCUMENT_DOWNLOAD
} from '../actions/actionTypes';

export function* handleCreateDocument(action) {
    try {
        const {type, groupId, metadata} = action.payload;
        const response = yield API.documentCreate(type, groupId, metadata);

        if (response.status !== 201) {
            throw new Error('Could not create document request');
        }

        const document = response.json;
        yield put(documentCreateSuccess(document));
        yield put(showNotification(i18n.t('document.export_started')));
    } catch (error) {
        yield put(documentCreateError(error.message));
        yield put(showNotification(i18n.t('document.export_error'), 'warning'));
    }
}

export function* handleDownloadDocument(action) {
    try {
        let {id} = action.payload;

        // Extract numeric ID if it's an IRI (e.g., "/api/documents/123" -> "123")
        if (typeof id === 'string' && id.includes('/')) {
            id = id.split('/').pop();
        }

        const response = yield API.documentGetDownloadUrl(id);

        if (response.status !== 200) {
            throw new Error('Could not get download URL');
        }

        const {download_url} = response.json;
        window.open(download_url, '_blank');
    } catch (error) {
        yield put(showNotification(i18n.t('document.download_error'), 'warning'));
    }
}

export function* documentSagas() {
    yield takeEvery(DOCUMENT_CREATE_REQUEST, handleCreateDocument);
    yield takeEvery(DOCUMENT_DOWNLOAD, handleDownloadDocument);
}
